// extracted by mini-css-extract-plugin
export default {"btn":"button_btn__ARPQ6","active":"button_active__eiP4N"};